import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { UsersIcon, InfoIcon } from 'lucide-react';
import Button from '../../components/ui/Button';
import { useOrder } from '../../context/OrderContext';
const GroupOrderParticipation: React.FC = () => {
  const {
    id
  } = useParams<{
    id: string;
  }>();
  const navigate = useNavigate();
  const {
    joinGroupOrder
  } = useOrder();
  // Mock group order data
  const [groupOrder] = useState({
    id,
    name: 'Office Lunch',
    initiator: 'Terry Crews',
    expiresAt: new Date(Date.now() + 30 * 60000),
    deliveryInfo: {
      date: 'Tomorrow',
      mealType: 'Lunch',
      timeSlot: '11:30 - 12:30'
    },
    individualPayment: true
  });
  const handleJoin = async () => {
    try {
      await joinGroupOrder(id!);
      navigate('/food');
    } catch (error) {
      console.error('Failed to join group order:', error);
    }
  };
  const timeRemaining = () => {
    const diff = groupOrder.expiresAt.getTime() - Date.now();
    const minutes = Math.floor(diff / 60000);
    return `${minutes} minutes`;
  };
  return <div className="max-w-3xl mx-auto px-4" data-id="element-559">
      <div className="bg-white rounded-lg shadow-md p-4 sm:p-6" data-id="element-560">
        <div className="flex items-center mb-4 sm:mb-6" data-id="element-561">
          <div className="w-10 h-10 bg-[#E84118] bg-opacity-10 rounded-full flex items-center justify-center mr-3 sm:mr-4" data-id="element-562">
            <UsersIcon size={20} className="text-[#E84118]" data-id="element-563" />
          </div>
          <div data-id="element-564">
            <h1 className="text-lg sm:text-xl font-bold" data-id="element-565">{groupOrder.name}</h1>
            <p className="text-xs sm:text-sm text-gray-600" data-id="element-566">
              Created by {groupOrder.initiator}
            </p>
          </div>
        </div>
        {/* Time remaining notice */}
        <div className="bg-yellow-50 border border-yellow-200 rounded-md p-3 sm:p-4 mb-5 sm:mb-6" data-id="element-567">
          <div className="flex items-start" data-id="element-568">
            <InfoIcon size={18} className="text-yellow-600 mr-2 sm:mr-3 mt-0.5" data-id="element-569" />
            <div data-id="element-570">
              <p className="font-medium text-yellow-800 text-sm sm:text-base" data-id="element-571">
                Time remaining: {timeRemaining()}
              </p>
              <p className="text-xs sm:text-sm text-yellow-700 mt-1" data-id="element-572">
                Please place your order before the group order expires
              </p>
            </div>
          </div>
        </div>
        {/* Delivery details */}
        <div className="bg-gray-50 rounded-md p-3 sm:p-4 mb-5 sm:mb-6" data-id="element-573">
          <h2 className="font-medium mb-2 sm:mb-3 text-sm sm:text-base" data-id="element-574">
            Delivery Details
          </h2>
          <div className="space-y-1 sm:space-y-2 text-xs sm:text-sm" data-id="element-575">
            <div className="flex justify-between" data-id="element-576">
              <span className="text-gray-600" data-id="element-577">Delivery Date:</span>
              <span className="font-medium" data-id="element-578">
                {groupOrder.deliveryInfo.date}
              </span>
            </div>
            <div className="flex justify-between" data-id="element-579">
              <span className="text-gray-600" data-id="element-580">Meal Type:</span>
              <span className="font-medium" data-id="element-581">
                {groupOrder.deliveryInfo.mealType}
              </span>
            </div>
            <div className="flex justify-between" data-id="element-582">
              <span className="text-gray-600" data-id="element-583">Delivery Time:</span>
              <span className="font-medium" data-id="element-584">
                {groupOrder.deliveryInfo.timeSlot}
              </span>
            </div>
          </div>
        </div>
        {/* Payment information */}
        <div className="bg-blue-50 border border-blue-200 rounded-md p-3 sm:p-4 mb-5 sm:mb-6" data-id="element-585">
          <h2 className="font-medium text-blue-800 mb-1 sm:mb-2 text-sm sm:text-base" data-id="element-586">
            Payment Information
          </h2>
          <p className="text-xs sm:text-sm text-blue-700" data-id="element-587">
            {groupOrder.individualPayment ? 'Each person will pay for their own order' : 'The group order creator will pay for everyone'}
          </p>
        </div>
        <div className="space-y-3 sm:space-y-4" data-id="element-588">
          <Button onClick={handleJoin} fullWidth size="lg" data-id="element-589">
            Join and Start Ordering
          </Button>
          <Button variant="outline" onClick={() => navigate('/')} fullWidth data-id="element-590">
            Cancel
          </Button>
        </div>
      </div>
    </div>;
};
export default GroupOrderParticipation;